import { SESSION_FRAGMENT } from './Path';
import { gql } from '@apollo/client';

export const GET_SESSION = gql`
${SESSION_FRAGMENT}
  query session($id: String!) {
    session(id: $id) {
    ...SessionFields
    }
  }
`;

export const GET_SESSION_USER_SEGMENTS = gql`
  query session($id: String!) {
    session(id: $id) {
      userSegments
    }
  }
`;

export const GET_ONBOARDING_SESSION = gql`
  query onboardingSession {
    onboardingSession {
      _id
    }
  }
`;

export const GET_REDO_SESSION = gql`
  query redoSession {
    redoSession {
      _id
    }
  }
`;

export const GET_DASHBOARD_SESSION = gql`
  query dashboardSession {
    dashboardSession {
      _id
    }
  }
`;

export const GET_AI_SESSIONS = gql`
query myAiSessions {
  aiSessions {
    _id
    title
    shortDescription
    order
    sessionType
    dateCreated
    steps {
      _id
      order
      contentType
      displayResult
      text
      content{
        _id
      }
      exercise {
        _id
      }
      survey{
        _id
      }
	}
  }
}
`;

/** the session playing a special flow (mhc, matching, instantHelp, scheduling, onboarding) */
export const SESSION_OF_TYPE = gql`
  query sessionOfType($sessionType: sessionType!) {
    sessionOfType(sessionType: $sessionType) {
      _id
      sessionType
    }
  }
`;
